'use server'

import { apiRequest, ApiResponse } from '../request'

export interface MedicalService {
    id: number
    name: string
    description?: string | null
    code?: string | null
    costPrice: number
    sellingPrice: number
    markupPercentage?: number | null
    maxDiscount?: number | null
    organizationId: number
    active: boolean
    createdAt: string
    updatedAt: string
}

export interface CreateMedicalServiceData {
    name: string
    organizationId?: number
    description?: string
    code?: string
    costPrice: number
    sellingPrice?: number
    markupPercentage?: number
    maxDiscount?: number
    active?: boolean
}

export interface UpdateMedicalServiceData extends Partial<CreateMedicalServiceData> {}

// ==================== CRUD ====================

export async function getMedicalServicesByOrganization(
    organizationId: number,
    params?: {
        activeOnly?: boolean
        page?: number
        limit?: number
        search?: string
        sortBy?: string
        sortOrder?: string
    }
): Promise<ApiResponse<MedicalService[]>> {
    const queryParams: Record<string, any> = {}
    if (params?.activeOnly) queryParams.activeOnly = 'true'
    if (params?.page) queryParams.page = params.page
    if (params?.limit) queryParams.limit = params.limit
    if (params?.search) queryParams.search = params.search
    if (params?.sortBy) queryParams.sortBy = params.sortBy
    if (params?.sortOrder) queryParams.sortOrder = params.sortOrder
    return apiRequest<MedicalService[]>(`medical-service/organization/${organizationId}`, { params: queryParams })
}

export async function getMedicalService(id: number): Promise<ApiResponse<MedicalService>> {
    return apiRequest<MedicalService>(`medical-service/${id}`, {})
}

export async function createMedicalService(data: CreateMedicalServiceData): Promise<ApiResponse<MedicalService>> {
    return apiRequest<MedicalService>('medical-service', { data }, 'post')
}

export async function updateMedicalService(id: number, data: UpdateMedicalServiceData): Promise<ApiResponse<MedicalService>> {
    return apiRequest<MedicalService>(`medical-service/${id}`, { data }, 'patch')
}

export async function toggleMedicalServiceActive(id: number): Promise<ApiResponse<MedicalService>> {
    return apiRequest<MedicalService>(`medical-service/${id}/toggle-active`, {}, 'patch')
}

export async function deleteMedicalService(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`medical-service/${id}`, {}, 'delete')
}
